
    // @ts-ignore
    module.exports = __webpack_public_path__ + "multiaudioplayer.worklet.js";
    